import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TemplatesDataProvider } from '@services/data-services/templates-data-service/templates.data.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { StringModifierServiceProvider } from '@services/helpers/string-modifier-service/stringModifier.service';
import {
	Contract,
	JobQuestionnarie,
	ContractsAndQuestionnaires
} from '@models/models';

@Component({
	selector: 'quote-contract-and-question',
	template: require('./quote-contract-and-question.html'),
	styles: [require('./quote-contract-and-question.scss')]
})
export class QuoteContractAndQuestionComponent {
	@Output()
	changeQuestionnaire: EventEmitter<object> = new EventEmitter<object>();
	@Output() changeContract: EventEmitter<object> = new EventEmitter<object>();
	@Output() disableButtons: EventEmitter<boolean> = new EventEmitter<boolean>();
	showModal = false;
	buttonDisable = false;
	contractBeforeEdit: Contract;
	questionnaire: JobQuestionnarie;
	contractQuestion: ContractsAndQuestionnaires;
	contractTemplates: Array<Contract> = [];
	questionnaireTemplates: Array<JobQuestionnarie>;
	updatedContract: Contract;
	contractToEdit: Contract = {
		text: ''
	};
	changedContractText;
	contractTextBeforeEdit;
	chosenContractId = -1;
	chosenQuestionnaireId = -1;
	isStartContractSigned = false;
	startContractId = -1;
	editEmptyContractObj: Contract = {
		text: ''
	};
	get contractAndQuestionnaireData(): ContractsAndQuestionnaires {
		return this.contractQuestion;
	}

	@Input('contractAndQuestionnaireData')
	set product(value: ContractsAndQuestionnaires) {
		this.contractQuestion = value;
		if (value) {
			this.setChosenItems(value);
			if (value.contract) {
				this.updateContract(value.contract.id);
			}
		}
	}

	constructor(
		private stringModifierService: StringModifierServiceProvider,
		private templatesDataService: TemplatesDataProvider,
		private messageService: MessageService
	) {}

	updateContract(contractId): void {
		this.chosenContractId = contractId !== 'null' ? +contractId : null;
		const contractIdNumber = parseInt(contractId);
		switch (contractIdNumber) {
			case -1:
				this.updatedContract = null;
				this.changeContract.emit(this.updatedContract);
				break;
			case this.contractBeforeEdit.id:
				this.updatedContract = JSON.parse(
					JSON.stringify(this.contractBeforeEdit)
				);
				this.changeContract.emit(this.updatedContract);
				break;
			default:
				this.getContract(contractIdNumber);
				break;
		}
	}

	updateQuestionnaire(questionnaireId): void {
		this.chosenQuestionnaireId = +questionnaireId;
		this.changeQuestionnaire.emit(questionnaireId);
	}

	openEditSelectContract(contractId, event): void {
		this.showModal = true;
		event.preventDefault();
		this.contractToEdit = JSON.parse(JSON.stringify(this.updatedContract));
		this.contractTextBeforeEdit = JSON.parse(
			JSON.stringify(this.contractToEdit.text)
		);
		// this is temporary solution that fixes text editor initialisation in modal
		setTimeout(() => {
			this.openModal();
		}, 0);
	}

	openModal() {
		$('#editSelectContractModal').modal('show');
	}

	resetContract() {
		this.showModal = false;
		this.contractToEdit.text = JSON.parse(
			JSON.stringify(this.contractTextBeforeEdit)
		);
	}

	saveEditedContract(event): void {
		this.showModal = false;
		event.preventDefault();
		$('#editSelectContractModal').modal('hide');
		if (this.contractToEdit && this.contractToEdit.name) {
			this.contractToEdit.name = this.stringModifierService.cutSelectedText(
				this.contractToEdit.name
			);
			this.messageService.showToaster(
				's_2',
				'contractTemplates',
				this.contractToEdit.name
			);
		}
		this.updatedContract = JSON.parse(JSON.stringify(this.contractToEdit));
		this.updatedContract.text = JSON.parse(
			JSON.stringify(this.changedContractText)
		);
		this.changeContract.emit(this.updatedContract);
	}

	changeContractText(text): void {
		this.changedContractText = text;
	}

	private getContract(contractId): void {
		this.buttonDisable = true;
		this.disableButtons.emit(true);
		this.templatesDataService
			.getTemplates('contract_full', contractId)
			.finally((): void => {
				this.disableButtons.emit(false);
				this.buttonDisable = false;
			})
			.subscribe(
				(contract): void => {
					this.updatedContract = JSON.parse(JSON.stringify(contract));
					this.changeContract.emit(this.updatedContract);
				},
				(error): void => this.messageService.showDefaultErrorMessage(error)
			);
	}

	private setChosenItems(data): void {
		const {
			contract,
			contractTemplates,
			questionnaire,
			questionnaireTemplates
		} = data;
		this.contractTemplates = contractTemplates || null;
		this.questionnaireTemplates = questionnaireTemplates || null;

		if (contract) {
			this.contractBeforeEdit = JSON.parse(JSON.stringify(contract));
			if (this.contractBeforeEdit.name) {
				this.contractBeforeEdit.name = this.stringModifierService.addSelectedText(
					this.contractBeforeEdit.name
				);
			}
			this.contractBeforeEdit.templateId = contract.id;
			this.contractTemplates.push(this.contractBeforeEdit);
			this.updatedContract = JSON.parse(
				JSON.stringify(this.contractBeforeEdit)
			);
			this.chosenContractId = this.contractBeforeEdit.id;
			this.checkIfContractSigned(this.contractBeforeEdit);
		} else {
			this.contractBeforeEdit = JSON.parse(
				JSON.stringify(this.editEmptyContractObj)
			);
		}

		if (questionnaire) {
			this.questionnaire = JSON.parse(JSON.stringify(questionnaire));
			if (this.questionnaire.name) {
				this.questionnaire.name = this.stringModifierService.addSelectedText(
					this.questionnaire.name
				);
			}
			this.questionnaireTemplates.push(this.questionnaire);
			this.chosenQuestionnaireId = this.questionnaire.id;
		}
	}

	private checkIfContractSigned(contract): void {
		this.isStartContractSigned = contract.signed;
		this.startContractId = contract.id;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/quotes/common/quote-contract-and-question/quote-contract-and-question.ts